import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import StatusBadge from "@/components/StatusBadge";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

export default function ReviewerDashboard() {
  const [tab, setTab] = useState("queue");
  const [stats, setStats] = useState(null);
  const [queue, setQueue] = useState([]);
  const [mine, setMine] = useState([]);

  useEffect(() => {
    api.get("/dashboard/reviewer").then((r) => setStats(r.data));
    api.get("/applications", { params: {} }).then((r) => setQueue(r.data));
    api.get("/applications", { params: { mine: true } }).then((r) => setMine(r.data));
  }, []);

  return (
    <Layout>
      <div className="fade-in space-y-6">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight" style={{fontFamily:'Outfit'}}>Reviewer console</h1>
          <p className="text-slate-600 text-sm mt-1">Verify documents, run checklists and recommend approvals.</p>
        </div>

        {stats && (
          <div className="grid sm:grid-cols-4 gap-4">
            <KPI label="Assigned to me" value={stats.assigned} testId="kpi-assigned"/>
            <KPI label="Needing review" value={stats.needing_review} testId="kpi-needing"/>
            <KPI label="Missing docs" value={stats.missing_docs} testId="kpi-missing"/>
            <KPI label="Failed eKYC" value={stats.failed_ekyc} testId="kpi-failed-ekyc"/>
          </div>
        )}

        <Tabs value={tab} onValueChange={setTab}>
          <TabsList data-testid="reviewer-tabs">
            <TabsTrigger value="queue" data-testid="tab-queue">Queue ({queue.length})</TabsTrigger>
            <TabsTrigger value="mine" data-testid="tab-mine">Assigned to me ({mine.length})</TabsTrigger>
          </TabsList>
          <TabsContent value="queue"><AppList apps={queue}/></TabsContent>
          <TabsContent value="mine"><AppList apps={mine}/></TabsContent>
        </Tabs>
      </div>
    </Layout>
  );
}

function KPI({ label, value, testId }) {
  return (
    <Card className="rounded-xl border-slate-200" data-testid={testId}>
      <CardContent className="p-5">
        <div className="text-xs uppercase tracking-widest text-slate-500">{label}</div>
        <div className="text-2xl font-semibold text-slate-900 mt-1" style={{fontFamily:'Outfit'}}>{value}</div>
      </CardContent>
    </Card>
  );
}

function AppList({ apps }) {
  return (
    <Card className="rounded-xl border-slate-200 mt-3"><CardContent className="p-0">
      {apps.length === 0 ? <div className="px-6 py-10 text-center text-slate-500">No applications.</div> : (
        <ul>
          {apps.map((a) => (
            <li key={a.id} className="px-4 sm:px-6 py-4 border-b last:border-b-0 border-slate-100 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3" data-testid={`reviewer-row-${a.id}`}>
              <div className="min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-medium text-slate-900">{a.product_name}</span>
                  <StatusBadge status={a.status}/>
                </div>
                <div className="text-sm text-slate-500 mt-0.5">{a.borrower_email} · ${a.amount.toFixed(2)} · {a.duration} {a.duration_unit}</div>
              </div>
              <Link to={`/reviewer/applications/${a.id}`} className="w-full sm:w-auto"><Button variant="outline" size="sm" className="w-full sm:w-auto" data-testid={`open-review-${a.id}`}>Open</Button></Link>
            </li>
          ))}
        </ul>
      )}
    </CardContent></Card>
  );
}
